// @flow
import * as React from 'react';
import { faAngleLeft } from '@fortawesome/pro-solid-svg-icons/faAngleLeft';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getCategoryFacetLink } from '../../utils/urls';
import isEqual from 'react-fast-compare';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import styles from './TaxonomyFacet.module.scss';

type Props = {
    categoryID: string,
    parents: any[],
    parentSelected: Function,
    queryParams: any,
    showLandingPageLinks: boolean,
};

const TaxonomyParent = ({ categoryID, queryParams, parents, parentSelected, showLandingPageLinks }: Props) => {
    if (parents && parents.length > 0) {
        return parents.map((parent, index) => {
            const icon = <FontAwesomeIcon className={styles.icon} icon={faAngleLeft} />;
            if (parents.length > index) {
                return (
                    <div key={parent.id} className={styles['option-parent']}>
                        {parent.landingPageUrl && showLandingPageLinks ? (
                            <Link
                                className={styles.link}
                                route
                                to={getCategoryFacetLink(parent.landingPageUrl, queryParams)}
                            >
                                {icon} {parent.name}
                            </Link>
                        ) : (
                            <a onClick={() => parentSelected(parent.id, categoryID)}>
                                {icon} {parent.name}
                            </a>
                        )}
                    </div>
                );
            }

            return (
                <div key={parent.id} className={styles.selected}>
                    {parent.name}
                </div>
            );
        });
    }

    return null;
};

export default React.memo<Props>(TaxonomyParent, isEqual);
